<template>
  <q-layout view="hHh LpR lFr" @mousedown="activeFn">
    <q-header v-if="!nude" reveal elevated class="bg-primary text-white">
      <q-toolbar style="padding: 0.5em">
        <q-btn dense flat round size="lg" icon="menu" @click="treeMenuOpen = !treeMenuOpen" :glossy="false">
          <q-tooltip>
            {{treeMenuOpen ? '收起左侧菜单' : '展开左侧菜单'}}
          </q-tooltip>
        </q-btn>

        <q-toolbar-title>
          <q-avatar square>
            <img src="@/assets/logo.svg">
          </q-avatar>
          {{appTitle}}
        </q-toolbar-title>

        <q-breadcrumbs style="font-size:1em; margin-right: 2em" active-color="white" separator-color="white">
          <q-breadcrumbs-el v-for="node in menuNodeChain" :key="node.path" :label="node.text" :icon="node.icon" />
        </q-breadcrumbs>
        <q-btn-dropdown dense flat size="lg" icon="account_circle" :label="$$user.username">
          <q-list>
            <q-item v-for="(item, index) in userMenuItems" :key="index" clickable v-close-popup @click="item.onClick && item.onClick()">
              <q-item-section avatar>
                <q-icon :name="item.icon" color="primary" />
              </q-item-section>
              <q-item-section>
                {{item.text}}
              </q-item-section>
              <q-item-section v-if="item.badge" side>
                <q-badge color="red">{{item.badge}}</q-badge>
              </q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>
        <q-btn size="lg" dense flat round @click="dialogs.theme.show = !dialogs.theme.show" icon="palette" :glossy="false">
          <q-tooltip>
            主题色
          </q-tooltip>
        </q-btn>
        <q-btn size="lg" dense flat round @click="$q.fullscreen.toggle()" :icon="$q.fullscreen.isActive ? 'fullscreen_exit' : 'fullscreen'" :glossy="false">
          <q-tooltip>
            {{$q.fullscreen.isActive ? '退出全屏' : '全屏'}}
          </q-tooltip>
        </q-btn>

        <q-btn v-if="false" dense flat round size="lg" icon="menu" @click="graphMenuOpen = !graphMenuOpen" :glossy="false">
          <q-tooltip>
            {{graphMenuOpen ? '收起右侧菜单' : '展开右侧菜单'}}
          </q-tooltip>
        </q-btn>
      </q-toolbar>
      <!-- <q-toolbar>
        <q-tabs dense v-model="menuNodePath" align="left" indicator-color="primary" class="text-primary" inline-label>
          <q-tab v-for="item in aliveMenuNodes" :key="item.path" :name="item.path" :icon="item.icon" :label="item.text">
            <q-btn v-show="!item.tab || item.tab.closable !== false" style="margin-left: 1em" icon="close" size="sm" round flat
              @click.stop="closeTab(item)" />
          </q-tab>
        </q-tabs>
      </q-toolbar> -->
    </q-header>

    <!-- 左侧经典口风琴菜单 -->
    <q-drawer v-if="!nude" v-model="treeMenuOpen" side="left" behavior="desktop" elevated :width="treeMenuWidth">
      <div style="height: 100%; display: flex; flex-flow: column nowrap;" class="bg-primary">
        <div style="padding: 1.5em 1.5em 0">
          <q-btn-toggle v-model="treeMenuViewName" spread dense class="menu-tree-toggle text-dark" no-caps rounded toggle-color="action-active"
            color="white" text-color="primary" :options="[
            // {label: '常用', value: 'common'}, //TODO:等后续后台完成该功能后再显示
            {label: '全部', value: 'all'},
            {label: '已开', value: 'opened'}
          ]" />
        </div>
        <div style="flex-grow: 1; flex-shrink: 1">
          <i-scroll-area class="q-pa-md" style="height: 100%">
            <i-tree-menu v-model="menuNodePath" :white-list="treeMenuWhiteList" :closable-node-paths="closableMenuNodePaths" @node-close="closeTab"/>
          </i-scroll-area>
        </div>
      </div>
    </q-drawer>

    <!-- 右侧流程图菜单 -->
    <q-drawer v-if="!nude" v-model="graphMenuOpen" side="right" behavior="desktop" overlay elevated :width="graphMenuWidth">
    </q-drawer>

    <!--动画效果影响响应时间, 暂去掉-->
    <!-- <q-page-container>
      <transition name="fade">
        <keep-alive :include="aliveMenuNodePaths">
          <i-keep-alive-decorator :component-name="menuNodePath">
            <router-view :key="menuNodePath" />
          </i-keep-alive-decorator>
        </keep-alive>
      </transition>
    </q-page-container> -->
    <q-page-container class="bg-theme-bg">
      <keep-alive :include="aliveMenuNodePaths">
        <!--注意：一个页面最好只保持一个router-view, 此处用v-if指令保证-->
        <i-keep-alive-decorator :component-name="menuNodePath" v-if="!menuNodeDialogMaximized">
          <!-- <a-config-provider :locale="zhCN"> -->
            <router-view :key="menuNodePath + $route.params.role || ''" />
          <!-- </a-config-provider> -->
        </i-keep-alive-decorator>
      </keep-alive>
    </q-page-container>
    <q-dialog v-if="menuNodeDialogMaximized" v-model="dialogs.page.show" persistent maximized transition-show="slide-up" transition-hide="slide-down">
      <q-card class="bg-theme-bg">
        <q-bar class="bg-primary" style="height:4vh">
          <q-space />
          <q-breadcrumbs active-color="white" separator-color="white">
            <q-breadcrumbs-el v-for="node in menuNodeChain" :key="node.path" :label="node.text" :icon="node.icon" class="text-white" />
          </q-breadcrumbs>
          <q-space />
          <q-btn dense icon="close" color="red" v-close-popup @click="closeTab($menuNode)" size="lg">
            <q-tooltip content-class="bg-white text-primary">关闭</q-tooltip>
          </q-btn>
        </q-bar>
        <q-card-section class="bg-theme-bg" style="padding:0">
          <div class="bg-theme-bg" style="margin:0;padding:0">
            <!--注意：一个页面最好只保持一个router-view, 此处用q-dialog的v-if指令保证-->
            <!-- <a-config-provider :locale="zhCN"> -->
              <router-view :key="menuNodePath" />
            <!-- </a-config-provider> -->
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-dialog v-model="dialogs.theme.show" seamless>
      <b-theme />
    </q-dialog>
  </q-layout>
</template>

<script>
import '@/styles/app.scss'
import BTheme from './BTheme.vue'
import BModifyPasswordVue from './BModifyPassword.vue'
import { StoreBisAuthorizeMixin } from '@/lib/mixins'
// import zhCN from 'ant-design-vue/es/locale/zh_CN'

export default {
  mixins: [StoreBisAuthorizeMixin],
  components: { BTheme },
  data () {
    return {
      displayLogin: false,
      unactiveTimer: null,
      // zhCN,
      menuNodePath: this.$menuNode?.path,
      aliveMenuNodes: [...this.$menu.nodes.filter(item => item.tab?.pinned)],
      appTitle: '智慧献血屋',

      // ------TODO------
      aliveMenuOpen: false,
      aliveMenuMiniState: true,
      // ------TODO------

      treeMenuViewName: 'all',
      treeMenuOpen: true,
      graphMenuOpen: false,
      userMenuItems: [
        { icon: 'password', text: '修改密码', onClick: this.modifyPassword },
        { icon: 'exit_to_app', text: '退出登录', onClick: this.$$logout }
      ],

      dialogs: {
        theme: {
          show: false
        },
        page: {
          show: false
        }
      },
      imgSrc: '',
      authLoading: false,
      noticeNum: 0,
      undoneList: [],
      labelMap: new Map()
    }
  },
  computed: {
    aliveMenuNodePaths () {
      return this.aliveMenuNodes.map(item => item.path)
    },
    closableMenuNodePaths () {
      return this.aliveMenuNodes.filter(item => !item.tab || item.tab.closable !== false).map(item => item.path)
    },
    menuNodeChain () {
      const chain = []
      for (let node = this.$menuNode; node; node = node.parent) {
        chain.unshift(node)
      }
      return chain
    },
    treeMenuWidth () {
      // return this.$q.screen.width * 0.1875
      return 260
    },
    treeMenuWhiteList () {
      if (this.treeMenuViewName === 'opened') {
        return this.aliveMenuNodePaths
      } else {
        return null
      }
    },
    graphMenuWidth () {
      // return this.$q.screen.width * 0.5
      return 950
    },
    nude () {
      return Boolean(this.$route.query['app.main.nude'])
    },
    menuNodeDialogMaximized () {
      return !!(this.$menuNode?.dialog?.maximized)
    }
  },
  watch: {
    $menuNode: function (menuNode) {
      this.updateMenuNode(menuNode)
    }
  },
  mounted () {
    console.log('user', this.$$user)
    this.updateMenuNode(this.$menuNode)
    window.addEventListener('mousedown', this.activeFn)
    window.addEventListener('keydown', this.activeFn)
  },
  methods: {
    loginSuccess () {
      this.displayLogin = false
    },
    activeFn () {
      this.displayLogin = false
      clearTimeout(this.unactiveTimer)
      this.unactiveTimer = setTimeout(() => {
        // 5min无人操作之后,展示登录框
        // 样本接收页面不弹
        if (this.$route.path !== '/transfusion/transfusion') {
          console.log('当前页面为：')
          console.log(this.$route.path)
          console.log('需要弹出登录验证')
          this.displayLogin = true
          this.$emit('close', this.displayLogin)
        }
      }, 5 * 60 * 1000)
    },
    updateMenuNode (menuNode) {
      document.title = menuNode?.text ? `${this.appTitle} - ${menuNode.text}` : this.appTitle
      if (menuNode && menuNode.link && !menuNode.dialog && !this.aliveMenuNodes.includes(menuNode)) {
        this.aliveMenuNodes.push(menuNode)
      }
      this.dialogs.page.show = !!menuNode?.dialog
    },
    closeTab (menuNode) {
      const isCurrent = this.$menuNode === menuNode
      const index = this.aliveMenuNodes.indexOf(menuNode)
      if (index >= 0) {
        this.aliveMenuNodes.splice(index, 1)
      }
      if (isCurrent) {
        this.menuNodePath = this.aliveMenuNodes.length
          ? this.aliveMenuNodes[this.aliveMenuNodes.length - 1].path : 'home'
      }
    },
    modifyPassword () {
      this.$q.dialog({
        parent: this,
        component: BModifyPasswordVue,
        // props forwarded to component
        // (everything except "component" and "parent" props above):
        userId: null
      }).onOk(args => {
        console.log('modify password succeed')
        this.$$logout()
      })
    },
    getLabel (group) {
      return this.labelMap.get(group).lable
    },
    getColor (group) {
      return this.labelMap.get(group).background
    }
  },
  provide () {
    const main = this
    return {
      $$closePage (page) {
        console.log('closePage', main, page)
        main.closeTab(page.$menuNode)
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/quasar.variables.scss";

.q-drawer {
  background-color: transparent !important;
}
.menu-tree-toggle {
  border: 1px solid $primary;
}
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0.5;
}
.q-pa-md {
  padding: 0px !important;
}
.tip {
  color: green;
  text-align: center;
  margin-top: 10px;
  font-size: 20px;
  font-weight: 600;
}
.loading {
  padding: 10px;
}
.noDataDiv{
  width: 100%;
  display: inline-block;
  text-align: center;
  font-size: 20px;
  margin-top: 60px;
  margin-bottom: 60px;
}
.undoneCategory{
  color: #008BBF;
}
.undoneDetail{
  font-size: 18px;
}
.undoneClass{
  font-size: 18px;
  width: 560px;
  font-weight: bold;
}
.undoleTableClass{
  border-collapse:separate;
  border-spacing:1px;
  margin-top: 20px;
}
</style>
